import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { RichText } from "web/react/emo/rich-text/rich-text";
import { Text } from "web/react/emo/text";
import * as styles from "./lyst-news-paragraph.css";

export interface ParagraphProps {
    text: string;
}

function makeHeading(Tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6") {
    return ({ children }: any) => (
        <Heading as={Tag} textStyle="hero-s">
            {children}
        </Heading>
    );
}

const markdownComponents = {
    h1: makeHeading("h1"),
    h2: makeHeading("h2"),
    h3: makeHeading("h3"),
    h4: makeHeading("h4"),
    h5: makeHeading("h5"),
    h6: makeHeading("h6"),
    p: ({ children }: any) => <Text textStyle={"body"}>{children}</Text>,
};

export function LystNewsParagraph({ text }: ParagraphProps): React.ReactElement {
    return (
        <RichText
            color="secondary"
            textStyle={{ sm: "body-s", md: "body" }}
            markdownProps={{ components: markdownComponents }}
            className={styles.richText}
        >
            {text}
        </RichText>
    );
}
